import { InMemoryCache } from '@apollo/client'

export function createCache(): InMemoryCache {
  return new InMemoryCache({})
}
